
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wom-seminar-2026",
      function () {
        return require("private-next-pages/wom-seminar-2026.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wom-seminar-2026"])
      });
    }
  